require('./bootstrap');

$(document).ready(function(){
    $(function() {
        $(".hamburger").click(function() {
            var isExpanded = $(this).attr('aria-expanded') === 'true';
            $(this).attr('aria-expanded', !isExpanded);
            $(this).toggleClass("is-active");
            $(".nav-links").toggleClass("show");
        });
    });

    $('input[type="checkbox"]')
        .each(function() {
            $(this).attr('aria-checked', this.checked ? 'true' : 'false');
        })
        .on('change', function() {
            $(this).attr('aria-checked', this.checked ? 'true' : 'false');
        });
});


